import path from 'path';
import { createHashHistory } from 'history';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardBody, CardHeader, ButtonGroup } from 'reactstrap';
import { viewPermissionSelector } from '../common/classes/permissions';
import { getReportNumberFromIssue } from '../reports/reportSelectors';
import entityComposition from '../common/classes/entityComposition';
import routeHelper from '../common/classes/routeHelper';
import IssuesFilterPanel from './issuesFilterPanel';
import IssuesBulkActions from './issuesBulkActions';
import IssuePagingTable from './issuePagingTable';
import IssuesRow from './issuesRow';
const hashHistory = createHashHistory();
const handleIssueClick = (reportDocumentID, issueID) => {
  let url;
  if (!reportDocumentID) {
    url = path.join('/issues', issueID);
  } else {
    url = path.join('/issues/detailView', reportDocumentID || '', issueID || '');
  }
  hashHistory.push(url);
};
const handleSelect = (id, event, issueActions) => {
  if (event.target.checked) {
    issueActions.select(id);
  } else {
    issueActions.selectClear(id);
  }
};
const handleSelectAll = (event, issue, issueActions) => {
  if (event && event.target.checked) {
    issueActions.selectAll(issue.list.map(i => i.id));
  } else {
    issueActions.selectClearAll();
  }
};
const Issues = props => {
  const canView = props.canView,
    location = props.location,
    _props$issue = props.issue,
    list = _props$issue.list,
    indexQuery = _props$issue.indexQuery,
    loading = _props$issue.loading,
    selected = _props$issue.selected,
    issue = props.issue,
    issueActions = props.issueActions,
    displaySettingsActions = props.displaySettingsActions,
    displaySettings = props.displaySettings;
  let reportHash = null;
  useEffect(() => {
    // Redirect and post authorization error message if permissions insufficient
    routeHelper.handleViewRedirect(canView, location);
  }, [canView, location]);
  useEffect(() => {
    issueActions.serverIndex(issue.indexQuery);
  }, [issueActions, issue.indexQuery]);
  useEffect(() => {
    // get displaySettings list for IssuesFilterPanel
    if (displaySettings.list.length === 0) {
      displaySettingsActions.serverIndex(displaySettings.indexQuery);
    }
  }, [displaySettingsActions, displaySettings.indexQuery, displaySettings.list]);
  const isReportFocused = indexQuery.filters.report && indexQuery.filters.report.length === 1;
  if (isReportFocused && list.length > 0) {
    const listItem = list[0];
    reportHash = getReportNumberFromIssue(listItem);
  }
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, issue ? /*#__PURE__*/React.createElement(IssuesFilterPanel, null) : undefined, /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "t-list-Card-header"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginTop: 'auto'
    },
    className: "t-main-title t-lp-title-issue-tracking"
  }, "Issue Tracking")), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement("h4", {
    style: {
      marginTop: 'auto'
    },
    className: "float-md-right t-report-id"
  }, reportHash !== null ? "Report ".concat(reportHash) : null)), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    className: "float-md-right"
  }, /*#__PURE__*/React.createElement(IssuesBulkActions, null))))))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(IssuePagingTable, {
    headers: [/*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      onChange: event => handleSelectAll(event, issue, issueActions)
    }), 'Label', 'Title', 'Items', 'Severity', 'Status', 'Creator', 'Created'],
    loading: loading,
    indexQuery: indexQuery
  }, list.map((nextIssue, index) => /*#__PURE__*/React.createElement(IssuesRow, {
    index: index,
    key: "Issue_".concat(nextIssue.id),
    data: nextIssue,
    onClick: handleIssueClick,
    hasActions: true,
    onSelect: (id, event) => handleSelect(id, event, issueActions),
    isSelected: (selected || []).includes(nextIssue.id)
  }))))))));
};
Issues.propTypes = {
  canView: PropTypes.bool.isRequired,
  displaySettings: PropTypes.shape({
    indexQuery: PropTypes.shape({
      initialized: PropTypes.bool
    }),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  displaySettingsActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  issue: PropTypes.shape({
    loading: PropTypes.bool,
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({
        report: PropTypes.arrayOf(PropTypes.shape({
          id: PropTypes.string.isRequired
        }))
      }),
      paging: PropTypes.shape({
        current: PropTypes.number.isRequired
      }).isRequired
    }).isRequired,
    selected: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  issueActions: PropTypes.shape({
    serverIndex: PropTypes.func,
    select: PropTypes.func,
    selectAll: PropTypes.func,
    selectClearAll: PropTypes.func,
    selectClear: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
};
export { Issues as TestIssues };
export default entityComposition(Issues, ['issue', 'displaySettings'], {
  canView: state => viewPermissionSelector('issue')(state)
}, []);